

<loading [isLoading]="isLoading" [isFullSize]="true"></loading>
<div>
  

  <!-- panel de lugares concurridos -->
  <!-- <div class="recurrent-container" cdkDrag>
    <recurrent-places *ngIf="geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible" class="button-container"></recurrent-places>
  </div> -->

  <!-- buscador, panel de locaciones y detalles de lacion -->
  <!-- <location-search-bar *ngIf="true" class="locaton-search-bar"></location-search-bar> -->
  <panel-locations (onCardClickedEmitter)="onFocusPin($event)" *ngIf="isVisiblePanel" ></panel-locations>
  <panel-detail-locations></panel-detail-locations>


<!-- <popup-map [$isVisiblePopupMap] ="_isVisiblePopUpMap"></popup-map> -->
<!-- <button mat-button color="primary" class="btn-layers" (click)="onChangeBaseMap()" >{{ _baseMapText }}</button> -->
<!-- <button mat-button color="primary" class="btn-update" (click)="onUpdateMap()" >{{ _UpdateBtnText }}</button> -->

</div>
